// ---------------------------------------------------------------
// Icon.js — Iconos de línea de la interfaz (SVG en línea, sin
// librerías ni descargas). Sustituyen a los emojis para que la web
// se vea igual en iPhone, Android, Windows y Mac, hereden el color
// del texto y funcionen en claro y oscuro.
//
// Uso:  <Icon name="trash" />        (16 px, color del texto)
//       <Icon name="sun" size={13} />
//       <Icon name="check" className="mi-clase" />
// ---------------------------------------------------------------

/* Trazos de cada icono, dibujados sobre una caja de 24×24 */
const PATHS = {
  // --- Acciones ---
  close: <path d="M6 6l12 12M18 6L6 18" />,
  edit: (
    <>
      <path d="M4 20h4L19 9a2.1 2.1 0 0 0-3-3L5 17v3z" />
      <path d="M14.5 6.5l3 3" />
    </>
  ),
  trash: (
    <>
      <path d="M4 7h16M9.5 7V5.2A1.2 1.2 0 0 1 10.7 4h2.6a1.2 1.2 0 0 1 1.2 1.2V7" />
      <path d="M6.5 7l.8 12.1A1.5 1.5 0 0 0 8.8 20.5h6.4a1.5 1.5 0 0 0 1.5-1.4L17.5 7" />
      <path d="M10.5 11v6M13.5 11v6" />
    </>
  ),
  check: <path d="M4.5 12.5l5 5 10-11" />,
  plus: <path d="M12 5v14M5 12h14" />,
  send: <path d="M20.5 3.5L10.5 13.5M20.5 3.5l-6.4 17-3.6-7-7-3.6 17-6.4z" />,
  undo: (
    <>
      <path d="M4 9h11a5 5 0 0 1 0 10h-4" />
      <path d="M8 5L4 9l4 4" />
    </>
  ),
  print: (
    <>
      <path d="M7 9V4h10v5" />
      <path d="M7 18H5a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-2" />
      <rect x="7" y="15" width="10" height="6" rx="1" />
    </>
  ),
  download: <path d="M12 4v11m0 0l-4.5-4.5M12 15l4.5-4.5M4.5 19.5h15" />,

  // --- Estados de la jornada ---
  sun: (
    <>
      <circle cx="12" cy="12" r="4" />
      <path d="M12 2.5v2M12 19.5v2M2.5 12h2M19.5 12h2M5.2 5.2l1.4 1.4M17.4 17.4l1.4 1.4M18.8 5.2l-1.4 1.4M6.6 17.4l-1.4 1.4" />
    </>
  ),
  sunset: (
    <>
      <path d="M3 18h18M6.5 18a5.5 5.5 0 0 1 11 0" />
      <path d="M12 3.5v3M4.6 8.6l1.5 1.5M19.4 8.6l-1.5 1.5" />
    </>
  ),
  moon: <path d="M20 14.5A8.5 8.5 0 0 1 9.5 4a8.5 8.5 0 1 0 10.5 10.5z" />,
  beach: (
    <>
      <path d="M12 21v-9" />
      <path d="M3.5 12a8.5 8.5 0 0 1 17 0z" />
      <path d="M20.5 19c-1.5 1.2-3 1.2-4.5 0s-3-1.2-4.5 0-3 1.2-4.5 0" />
    </>
  ),
  health: (
    <>
      <path d="M20.5 8.5a4.6 4.6 0 0 0-8.5-2.5A4.6 4.6 0 0 0 3.5 8.5c0 5 8.5 11 8.5 11s8.5-6 8.5-11z" />
      <path d="M12 9.5v4M10 11.5h4" />
    </>
  ),
  party: (
    <>
      <path d="M4 20.5l4.5-12 7.5 7.5-12 4.5z" />
      <path d="M14.5 4.5v2M19.5 9.5h-2M18.4 5.6l-1.4 1.4" />
    </>
  ),
  clock: (
    <>
      <circle cx="12" cy="12" r="8.5" />
      <path d="M12 7v5.2l3.2 2" />
    </>
  ),
  repeat: (
    <>
      <path d="M4 12V9.5A3.5 3.5 0 0 1 7.5 6H19" />
      <path d="M16 3l3 3-3 3" />
      <path d="M20 12v2.5a3.5 3.5 0 0 1-3.5 3.5H5" />
      <path d="M8 21l-3-3 3-3" />
    </>
  ),

  // --- Personas y contenido ---
  team: (
    <>
      <circle cx="9" cy="8" r="3.2" />
      <path d="M3 19.5a6 6 0 0 1 12 0" />
      <path d="M16 5.4a3.2 3.2 0 0 1 0 5.2M17.5 14.2a6 6 0 0 1 3.5 5.3" />
    </>
  ),
  person: (
    <>
      <circle cx="12" cy="8" r="3.6" />
      <path d="M5 20a7 7 0 0 1 14 0" />
    </>
  ),
  clipboard: (
    <>
      <rect x="5" y="4.5" width="14" height="16" rx="2" />
      <path d="M9 4.5V3.8A1.3 1.3 0 0 1 10.3 2.5h3.4A1.3 1.3 0 0 1 15 3.8v.7" />
      <path d="M9 11h6M9 15h4" />
    </>
  ),
  pin: (
    <>
      <path d="M12 21v-6" />
      <path d="M8 3h8l-1 6 3 3H6l3-3-1-6z" />
    </>
  ),
  link: (
    <>
      <path d="M10.5 13.5a4 4 0 0 0 5.7 0l2.5-2.5a4 4 0 0 0-5.7-5.7l-1.3 1.3" />
      <path d="M13.5 10.5a4 4 0 0 0-5.7 0l-2.5 2.5a4 4 0 0 0 5.7 5.7l1.3-1.3" />
    </>
  ),
  place: (
    <>
      <path d="M12 21s7-6.2 7-11a7 7 0 1 0-14 0c0 4.8 7 11 7 11z" />
      <circle cx="12" cy="10" r="2.6" />
    </>
  ),
  bell: (
    <>
      <path d="M18 9a6 6 0 1 0-12 0c0 6-2.5 7-2.5 7h17S18 15 18 9" />
      <path d="M10 20a2.2 2.2 0 0 0 4 0" />
    </>
  ),
  warning: (
    <>
      <path d="M12 3.8L21 19.5H3L12 3.8z" />
      <path d="M12 10v4.2M12 17.2v.1" />
    </>
  ),
  info: (
    <>
      <circle cx="12" cy="12" r="8.5" />
      <path d="M12 11v5.5M12 7.8v.1" />
    </>
  ),
  sparkle: (
    <path d="M12 3.5l1.9 5.1 5.1 1.9-5.1 1.9L12 17.5l-1.9-5.1L5 10.5l5.1-1.9L12 3.5z" />
  ),
  palette: (
    <>
      <path d="M12 3.5a8.5 8.5 0 0 0 0 17c1.4 0 2-.9 2-1.8 0-1.3-1.1-1.7-1.1-2.8 0-.8.7-1.4 1.6-1.4h1.6a4.4 4.4 0 0 0 4.4-4.4c0-3.7-3.8-6.6-8.5-6.6z" />
      <circle cx="8.2" cy="11" r="1" fill="currentColor" stroke="none" />
      <circle cx="11" cy="7.8" r="1" fill="currentColor" stroke="none" />
      <circle cx="15" cy="8.6" r="1" fill="currentColor" stroke="none" />
    </>
  ),
  inbox: (
    <>
      <path d="M3.5 13.5h4l1.5 3h6l1.5-3h4" />
      <path d="M5.6 5.2h12.8l2.1 8.3v4a2 2 0 0 1-2 2H5.5a2 2 0 0 1-2-2v-4l2.1-8.3z" />
    </>
  ),

  // --- Guía rápida: teléfonos de emergencia ---
  phone: (
    <path d="M6.5 3.5h3l1.5 3.7-1.9 1.3a12 12 0 0 0 5.4 5.4l1.3-1.9 3.7 1.5v3a2 2 0 0 1-2.2 2A16.5 16.5 0 0 1 4.5 5.7a2 2 0 0 1 2-2.2z" />
  ),
  flame: (
    <path d="M12 21a6 6 0 0 0 6-6c0-4-3-5.5-3-9 0 0-2 1.5-2 4 0-1.5-1-3-2.5-3.5 0 3-4.5 4.5-4.5 8.5a6 6 0 0 0 6 6z" />
  ),
  shield: (
    <>
      <path d="M12 3l7 3v5.5c0 4.4-3 8-7 9.5-4-1.5-7-5.1-7-9.5V6l7-3z" />
      <path d="M9.2 12.2l2 2 3.6-3.8" />
    </>
  ),
  siren: (
    <>
      <path d="M7 13a5 5 0 0 1 10 0v4H7v-4z" />
      <path d="M4.5 20.5h15M12 3v2M4.6 6.6l1.4 1.4M19.4 6.6L18 8" />
    </>
  ),
  support: (
    <>
      <path d="M4 13a8 8 0 0 1 16 0" />
      <rect x="3" y="13" width="3.6" height="6" rx="1.6" />
      <rect x="17.4" y="13" width="3.6" height="6" rx="1.6" />
      <path d="M20 19v.6a2.4 2.4 0 0 1-2.4 2.4H13" />
    </>
  ),
  cross: (
    <>
      <rect x="3.5" y="3.5" width="17" height="17" rx="4" />
      <path d="M12 8v8M8 12h8" />
    </>
  ),

  // --- Fichaje ---
  play: <path d="M8 5.5l11 6.5-11 6.5v-13z" fill="currentColor" stroke="none" />,
  square: (
    <rect x="6" y="6" width="12" height="12" rx="2.5" fill="currentColor" stroke="none" />
  ),

  lock: (
    <>
      <rect x="4.5" y="10.5" width="15" height="10" rx="2.5" />
      <path d="M8 10.5V7.6a4 4 0 0 1 8 0v2.9" />
    </>
  ),
  medal: (
    <>
      <circle cx="12" cy="14.5" r="5.5" />
      <path d="M8.5 9.6L6.5 3.5h11l-2 6.1" />
      <path d="M12 12.4l.9 1.8 2 .3-1.5 1.4.4 2-1.8-1-1.8 1 .4-2-1.5-1.4 2-.3.9-1.8z" />
    </>
  ),
  chart: (
    <>
      <path d="M4 20V4M4 20h16" />
      <path d="M8 20v-6M12.5 20V9M17 20v-9" />
    </>
  ),
  scale: (
    <>
      <path d="M12 4v16M7 20h10M12 6l-6 2 6-2 6 2" />
      <path d="M3 14a3 3 0 0 0 6 0l-3-6-3 6zM15 14a3 3 0 0 0 6 0l-3-6-3 6z" />
    </>
  ),

  search: (
    <>
      <circle cx="11" cy="11" r="6.5" />
      <path d="M16 16l4.5 4.5" />
    </>
  ),
  external: (
    <>
      <path d="M14 4h6v6" />
      <path d="M20 4l-8.5 8.5" />
      <path d="M18 14v4.5a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 4 18.5v-11A1.5 1.5 0 0 1 5.5 6H10" />
    </>
  ),

  eye: (
    <>
      <path d="M2.5 12S6 5.5 12 5.5 21.5 12 21.5 12 18 18.5 12 18.5 2.5 12 2.5 12z" />
      <circle cx="12" cy="12" r="3" />
    </>
  ),
  drag: (
    <>
      <circle cx="9" cy="6" r="1.4" fill="currentColor" stroke="none" />
      <circle cx="15" cy="6" r="1.4" fill="currentColor" stroke="none" />
      <circle cx="9" cy="12" r="1.4" fill="currentColor" stroke="none" />
      <circle cx="15" cy="12" r="1.4" fill="currentColor" stroke="none" />
      <circle cx="9" cy="18" r="1.4" fill="currentColor" stroke="none" />
      <circle cx="15" cy="18" r="1.4" fill="currentColor" stroke="none" />
    </>
  ),
  // --- Caras para la valoración del turno ---
  // Dibujadas a línea como el resto, en vez de emoji: los emoji los
  // pinta cada sistema a su manera y aquí desentonaban.
  caraBien: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="M8.5 14.5c.9 1.2 2.1 1.8 3.5 1.8s2.6-.6 3.5-1.8" />
      <path d="M9 9.5h.01M15 9.5h.01" />
    </>
  ),
  caraRegular: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="M8.5 15h7" />
      <path d="M9 9.5h.01M15 9.5h.01" />
    </>
  ),
  caraMal: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="M8.5 16.3c.9-1.2 2.1-1.8 3.5-1.8s2.6.6 3.5 1.8" />
      <path d="M9 9.5h.01M15 9.5h.01" />
    </>
  ),
  chevron: <path d="M6 9l6 6 6-6" />,

  wifi: (
    <>
      <path d="M2.5 9.2a15 15 0 0 1 19 0" />
      <path d="M5.8 12.8a10 10 0 0 1 12.4 0" />
      <path d="M9 16.3a5 5 0 0 1 6 0" />
      <path d="M12 20v.1" />
    </>
  ),

  // Dedo pulsando (botón de fichar) y móvil
  tap: (
    <>
      <path d="M9 11.5V6a2 2 0 0 1 4 0v5" />
      <path d="M13 11v-1a2 2 0 0 1 4 0v1" />
      <path d="M17 11.5a2 2 0 0 1 4 0v3.5a6 6 0 0 1-6 6h-1.6a5 5 0 0 1-3.8-1.8l-3.4-4a1.8 1.8 0 0 1 2.6-2.4L11 14" />
    </>
  ),
  device: (
    <>
      <rect x="7" y="2.5" width="10" height="19" rx="2.5" />
      <path d="M11 18.5h2" />
    </>
  ),
};

export default function Icon({ name, size = 16, className = "", title }) {
  const d = PATHS[name];
  if (!d) return null;
  return (
    <svg
      className={`ui-icon ${className}`}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      role={title ? "img" : undefined}
      aria-label={title}
      aria-hidden={title ? undefined : true}
      focusable="false"
    >
      {d}
    </svg>
  );
}
